import React, { useState, useEffect } from 'react';
import { Button, Icon, Menu, Avatar, Modal as ModalAntd } from 'antd';
import Modal from '../../components/Modal';
import Logo from '../../assets/img/png/Logo-icontec.png';
import NoAvatar from '../../assets/img/png/no-avatar.png';
import { logout } from '../../api/auth';

import './MenuTop.scss';
import EditUserInfoForm from '../Admin/Users/EditUserInfoForm';
import EditUserPassForm from '../Admin/Users/EditUserPassForm';

const { SubMenu } = Menu;

const { confirm } = ModalAntd;

export default function MenuTop(props) {
	const { menuCollpased, setMenuCollpased, userBD } = props;
	const [dataUser, setDataUser] = useState(userBD);

	const [isVisibleModal, setIsVisibleModal] = useState(false);
	const [modalTitle, setModalTitle] = useState('');
	const [modalContent, setModalContent] = useState(null);

	const logoutUser = () => {
		logout();
		window.location.reload();
	};

	return (
		<div>
			<div className="menu-top">
				<div className="menu-top__left">
					<img className="menu-top__left-logo" src={Logo} alt="Portal Proveedores ICONTEC" />
					<Button type="link" onClick={() => setMenuCollpased(!menuCollpased)}>
						<Icon type={menuCollpased ? 'menu-unfold' : 'menu-fold'} />
					</Button>
				</div>
				<div className="menu-top__right">
					<UserData
						dataUser={dataUser}
						setDataUser={setDataUser}
						setIsVisibleModal={setIsVisibleModal}
						setModalTitle={setModalTitle}
						setModalContent={setModalContent}
					/>
					<Button type="link" onClick={logoutUser}>
						<h1h className="menu-top__left-logo">Salir</h1h>
					</Button>
				</div>
			</div>
			<Modal title={modalTitle} isVisible={isVisibleModal} setIsVisible={setIsVisibleModal}>
				{modalContent}
			</Modal>
		</div>
	);
}

function UserData(props) {
	const { dataUser, setDataUser, setIsVisibleModal, setModalTitle, setModalContent } = props;
	/*const token = getAccesTokenApi();
	const [avatar, setAvatar] = useState('');

	useEffect(() => {
		getUserApi(token, getIdUser()).then((result) => {
			setAvatar(result.resultado[0].avatar);
		});
	}, []);*/

	let rol = dataUser.id_rol;

	console.log('usuario logueado: ' + dataUser.login);

	//if (userData.id_rol === 2) {
	if (rol === 2) {
		return (
			<UserDataUser
				setDataUser={setDataUser}
				dataUser={dataUser}
				setIsVisibleModal={setIsVisibleModal}
				setModalTitle={setModalTitle}
				setModalContent={setModalContent}
			/>
		);
		//} else if (userData.id_rol === 1) {
	} else if (rol === 1) {
		return <UserDataAdmin dataUser={dataUser} />;
	}
}

function UserDataUser(props) {
	const { dataUser, setDataUser, setIsVisibleModal, setModalTitle, setModalContent } = props;
	const [current, setCurrent] = useState('');

	useEffect(() => {
		if (dataUser.login === 0) {
			confirm({
				title: 'Cambiar Contraseña',
				content: `Bienvenido al portal de proveedores, es la primera vez que ingresas a la plataforma o has realizado un cambio de contraseña ¿deseas realizar el cambio de la contraseña en este momento?`,
				okText: 'Cambiar Contraseña',
				okType: 'danger',
				cancelText: 'Cancelar',
				onOk() {
					chgPwd();
				},
			});
		}
	}, []);

	const chgPwd = () => {
		setIsVisibleModal(true);
		setModalTitle(`Cambiar Contraseña`);
		setModalContent(
			<EditUserPassForm user={dataUser} setUser={setDataUser} setIsVisibleModal={setIsVisibleModal} />
		);
		setCurrent('');
	};

	const handleClick = (e) => {
		setCurrent(e.key);

		switch (e.key) {
			case 'updData':
				setIsVisibleModal(true);
				setModalTitle(`Actualizar Información`);
				setModalContent(
					<EditUserInfoForm user={dataUser} setUser={setDataUser} setIsVisibleModal={setIsVisibleModal} />
				);
				setCurrent('');
				break;
			case 'chgPass':
				chgPwd();
				break;
			default:
				break;
		}
	};

	return (
		<Menu
			onClick={handleClick}
			selectedKeys={[current]}
			mode="horizontal"
			theme="dark"
			className="menu-top__right_menu"
		>
			<SubMenu
				title={
					<span className="submenu-title-wrapper">
						<Avatar
							size={25}
							src={dataUser.avatar !== '' && dataUser.avatar !== null ? dataUser.avatar : NoAvatar}
							className="menu-top__right_menu_avt"
						/>
						{
							//infoUser()
							dataUser.nombre + ' ' + dataUser.apellido
						}
					</span>
				}
			>
				{/*<Menu.ItemGroup title="Item 1">
					<Menu.Item key="setting:1">Option 1</Menu.Item>
					<Menu.Item key="setting:2">Option 2</Menu.Item>
			</Menu.ItemGroup>*/}

				<Menu.Item key="updData">Actualizar Informacion</Menu.Item>
				<Menu.Item key="chgPass">Cambiar Contraseña</Menu.Item>
			</SubMenu>
		</Menu>
	);
}

function UserDataAdmin(props) {
	const { dataUser } = props;

	return (
		<Menu
			//onClick={handleClick}
			//selectedKeys={[current]}
			mode="horizontal"
			theme="dark"
			className="menu-top__right_menu"
		>
			<SubMenu
				title={
					<span className="submenu-title-wrapper">
						<Avatar
							size={40}
							src={dataUser.avatar !== '' && dataUser.avatar !== null ? dataUser.avatar : NoAvatar}
							className="menu-top__right_menu_avt"
						/>
						{
							//infoUser()
							dataUser.nombre + ' ' + dataUser.apellido
						}
					</span>
				}
			></SubMenu>
		</Menu>
	);
}
